import {gql, useQuery} from '@apollo/client';

/**
 * 申诉审核「待DSP提交」批量作废开关，对应 api-server `CommonConfigQuery.checkPartnerPenaltyBatchVoidEnabled`。
 * 配置键固定在后端（partner_penalty.batch_void_enable），前端不传。
 */
export const CHECK_PARTNER_PENALTY_BATCH_VOID_ENABLED = gql`
    query CheckPartnerPenaltyBatchVoidEnabled {
        checkPartnerPenaltyBatchVoidEnabled
    }
`;

interface CheckPartnerPenaltyBatchVoidEnabledResponse {
    checkPartnerPenaltyBatchVoidEnabled: boolean;
}

/** 加载中或查询失败时 data 为空，退化为 false，即隐藏按钮 */
export const useCheckPartnerPenaltyBatchVoidEnabled = (): boolean => {
    const {data} = useQuery<CheckPartnerPenaltyBatchVoidEnabledResponse>(CHECK_PARTNER_PENALTY_BATCH_VOID_ENABLED, {
        fetchPolicy: 'network-only',
    });
    return data?.checkPartnerPenaltyBatchVoidEnabled ?? false;
};
